import { ca } from '@cian/analytics';
import { useSelector } from 'react-redux';

import { selectOffer, selectOfferId } from 'shared/selectors';

export const useCpdTracking = () => {
  const offer = useSelector(selectOffer);
  const offerId = useSelector(selectOfferId);

  const products = [
    {
      id: offerId,
      offerType: 'offer',
      position: 1,
    },
  ];

  const trackCPDTrapVisible = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'trapOffer',
      action: 'Show_sopr',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          cpdOfferType: offer.category,
        },
      },
    });
  };

  const trackCPDTrapClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'trapOffer',
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          cpdOfferType: offer.category,
        },
      },
    });
  };

  const trackCPDModalVisible = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Popup',
      action: 'Open',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source: 'trapOffer',
          cpdOfferType: offer.category,
        },
      },
    });
  };

  const trackCPDCreateDraftClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Send',
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source: 'trapOffer',
          cpdOfferType: offer.category,
        },
      },
    });
  };

  const trackCPDDetailClick = () => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Detail',
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source: 'trapOffer',
          cpdOfferType: offer.category,
        },
      },
    });
  };

  const trackCPDSuccessScreenVisible = (cpdDraftId?: number) => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'Success',
      action: 'Send',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source: 'trapOffer',
          draft_id: cpdDraftId,
          cpdOfferType: offer.category,
        },
      },
    });
  };

  const trackCPDGoToChatClick = (cpdDraftId?: number) => {
    ca('eventSite', {
      name: 'oldevent',
      label: 'ToChat',
      action: 'Click',
      category: 'DemandCpd',
      products,
      page: {
        extra: {
          source: 'trapOffer',
          draft_id: cpdDraftId,
          cpdOfferType: offer.category,
        },
      },
    });
  };

  return {
    trackCPDTrapVisible,
    trackCPDTrapClick,
    trackCPDModalVisible,
    trackCPDCreateDraftClick,
    trackCPDDetailClick,
    trackCPDSuccessScreenVisible,
    trackCPDGoToChatClick,
  };
};
